export function TypingIndicator() {
  return (
    <div
      className="bg-white rounded-[16px] inline-flex items-center gap-1 px-3 py-2 shadow-[0_1px_0.5px_rgba(0,0,0,0.13)]"
      aria-label="digitando"
      role="status"
    >
      <span className="wa-typing-dot block w-2 h-2 rounded-full bg-[#8696A0]" />
      <span className="wa-typing-dot block w-2 h-2 rounded-full bg-[#8696A0]" />
      <span className="wa-typing-dot block w-2 h-2 rounded-full bg-[#8696A0]" />
    </div>
  );
}
